module.exports = __webpack_public_path__ + "static/media/pexels-photo-288476.c8dc038c.jpeg";